import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["inputId", "index", "parentObject", "skipValidation"];
import { Field } from "formik";
import * as React from "react";
import { useSelector } from "react-redux";
var QnbInput = function QnbInput(_ref) {
    var inputId = _ref.inputId, index = _ref.index, parentObject = _ref.parentObject, _ref$skipValidation = _ref.skipValidation, skipValidation = _ref$skipValidation === void 0 ? false : _ref$skipValidation, prop = _objectWithoutPropertiesLoose(_ref, _excluded);
    var loadedInput = useSelector(function (state) { return state.qnbProduct.loadedComponents.input[inputId]; });
    function validate(props) {
        var _loadedInput$validati; // console.log("validating: ", inputId, props);
        return (_loadedInput$validati = loadedInput.validation) === null || _loadedInput$validati === void 0 ? void 0 : _loadedInput$validati.call(loadedInput, props, skipValidation);
    }
    if (!(loadedInput !== null && loadedInput !== void 0 && loadedInput.component)) {
        return /*#__PURE__*/ React.createElement("div", null, "Cannot load qnbInput component: ", inputId);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Field, Object.assign({ validate: validate, name: "" + (parentObject ? parentObject + "." : "") + (parentObject && typeof index === "number" ? index + "." : "") + inputId, component: loadedInput.component }, prop)));
};
export default QnbInput;
